import React from 'react';
import PropTypes from 'prop-types';
import DisplayPrice from './display-price';
import ProductWasPrice from './product-was-price';
import wasPriceType from './types/was-price-type';

function ProductPrice(props) {
  const { price, price_range: priceRange, set_size: setSize } = props;

  if (setSize) {
    return (
      <p className="price price-set">
        <DisplayPrice price={price} />
        <ProductWasPrice {...props} />
        <span className="price-set-each" data-test-id="price-set">
          <DisplayPrice price={Math.round(price / setSize)} /> / each
        </span>
      </p>
    );
  }

  if (priceRange) {
    const [priceFrom, priceTo] = priceRange;

    return (
      <p className="price price-range" data-test-id="price-range">
        <DisplayPrice price={priceFrom} />
        &nbsp;&ndash;&nbsp;
        <DisplayPrice price={priceTo} />
      </p>
    );
  }

  return (
    <p className="price">
      <DisplayPrice price={price} />
      <ProductWasPrice {...props} />
    </p>
  );
}

ProductPrice.propTypes = {
  price: PropTypes.number,
  price_range: PropTypes.arrayOf(PropTypes.number),
  set_size: PropTypes.number,
  was_price: wasPriceType,
};

ProductPrice.defaultProps = {
  price: null,
  price_range: null,
  set_size: null,
  was_price: null,
};

export default ProductPrice;
